
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientwarmingblanketslucknow() {



  const cardData =
  {
    keyword: 'Patient Warming Blankets in Lucknow',
    heading: 'Pharmacle Health Care Private Limited: Patient Warming Blankets in Lucknow',
    headingDescription: 'Pharmacle Health Care Private Limited provides high-quality Patient Warming Blankets in Lucknow, ensuring effective temperature management for patients during surgeries and critical care. Our Wallabies Warm Care blankets are designed to prevent hypothermia by delivering consistent and controlled warming, enhancing patient safety and recovery. Widely used in hospitals and healthcare facilities, our patient warming blankets are reliable, easy to use, and built with advanced technology. Choose Pharmacle Health Care for the best warming solutions in Lucknow to improve patient care and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',

   "topPlaces": [
  {
    "title": "Patient Warming Blankets in Lucknow",
    "description": "Pharmacle Health Care Private Limited provides high-quality patient warming blankets in Lucknow, ensuring effective temperature management for surgical, ICU, and emergency patients. Our solutions help prevent hypothermia and enhance overall recovery outcomes."
  },
  {
    "title": "Disposable Patient Warming Blankets",
    "description": "Pharmacle Health Care Private Limited offers single-use disposable warming blankets that help maintain normothermia while minimizing infection risks in hospitals and clinics. These hygienic blankets are trusted by healthcare providers for safe patient care."
  },
  {
    "title": "Reusable Thermal Warming Blankets",
    "description": "Eco-friendly and cost-effective, our reusable thermal warming blankets deliver consistent and reliable patient warming across multiple medical applications. Pharmacle Health Care Private Limited ensures long-lasting performance with quality-tested designs."
  },
  {
    "title": "Surgical Warming Blankets",
    "description": "Pharmacle Health Care Private Limited manufactures surgical warming blankets specifically for operating rooms. These blankets ensure stable body temperature during surgery, reducing the risk of perioperative hypothermia and associated complications."
  },
  {
    "title": "ICU Patient Warming Blankets",
    "description": "Our ICU warming blankets provide continuous thermal support for critically ill patients in intensive care units. Pharmacle Health Care Private Limited’s advanced designs help improve patient stability, safety, and recovery in Lucknow’s leading hospitals."
  },
  {
    "title": "Neonatal Warming Blankets",
    "description": "Pharmacle Health Care Private Limited specializes in neonatal warming blankets for NICUs and maternity wards in Lucknow. These blankets offer gentle, precise temperature regulation for newborns and premature infants, ensuring safe thermal care."
  },
  {
    "title": "Emergency Patient Warming Blankets",
    "description": "Ideal for trauma and emergency response, our patient warming blankets rapidly stabilize body temperature in critical cases. Pharmacle Health Care Private Limited ensures hospitals and ambulances in Lucknow are equipped with reliable emergency warming solutions."
  },
  {
    "title": "Veterinary Warming Blankets",
    "description": "Pharmacle Health Care Private Limited extends expertise to veterinary care with advanced warming blankets for animals. Trusted by clinics in Lucknow, these blankets provide safe and effective thermal support during surgeries and treatments."
  },
  {
    "title": "Preoperative & Postoperative Warming Blankets",
    "description": "Our pre- and postoperative warming blankets maintain patient body temperature before and after surgery, enhancing comfort and reducing recovery time. Pharmacle Health Care Private Limited ensures effective perioperative thermal care in Lucknow hospitals."
  },
  {
    "title": "Portable Patient Warming Blankets",
    "description": "Pharmacle Health Care Private Limited offers lightweight and portable warming blankets, perfect for ambulances, emergency rooms, and field hospitals in Lucknow. These blankets ensure reliable warmth and comfort during patient transport."
  }
],


"services": [
    {
        "name": "Patient Warming Blankets Lucknow",
        "description": "Pharmacle Health Care Private Limited offers patient warming blankets in Lucknow, designed to maintain a stable body temperature during surgeries, recovery, and critical care. These blankets help prevent hypothermia and ensure patient safety and comfort."
    },
    {
        "name": "Lucknow Forced Air Warming Blankets",
        "description": "We provide forced air warming blankets in Lucknow that use warm air circulation to effectively maintain the body temperature of patients during medical treatments. These blankets are ideal for surgical settings, ensuring patients stay warm and comfortable."
    },
    {
        "name": "Warming Blankets for Patients in Lucknow",
        "description": "Our warming blankets for patients in Lucknow are designed to provide controlled and consistent warmth, preventing hypothermia during medical procedures. These blankets are a reliable solution for ensuring patient comfort during recovery and treatment."
    },
    {
        "name": "Patient Warming Systems Lucknow",
        "description": "We offer advanced patient warming systems in Lucknow that regulate body temperature during surgeries and recovery. These systems ensure that patients maintain a stable body temperature, improving safety and comfort throughout medical treatments."
    },
    {
        "name": "Lucknow Medical Warming Blankets",
        "description": "Pharmacle Health Care provides medical warming blankets in Lucknow to regulate patient body temperature in critical care, surgery, and recovery settings. These blankets are essential for preventing temperature-related complications and ensuring patient well-being."
    },
    {
        "name": "Lucknow Patient Temperature Regulation Blankets",
        "description": "Our patient temperature regulation blankets in Lucknow help maintain a controlled and comfortable body temperature during medical procedures. These blankets are crucial for patients undergoing surgery or recovery, providing a safe and effective solution for temperature management."
    }
],
"tableData": [
    ["- Patient Warming Blankets Lucknow", "- Lucknow Forced Air Warming Blankets"],
    ["- Warming Blankets for Patients in Lucknow", "- Patient Warming Systems Lucknow"],
    ["- Lucknow Medical Warming Blankets", "- Lucknow Patient Temperature Regulation Blankets"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced patient warming blankets in Lucknow, designed to provide precise temperature control during medical treatments. Our technology ensures reliable performance to prevent hypothermia, enhancing patient safety in hospitals and clinics across Lucknow."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a wide range of patient warming blankets in Lucknow, including forced air warming blankets and temperature control systems. Our solutions are tailored for both surgical procedures and critical care, ensuring your patients remain comfortable and safe throughout their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our patient warming blankets are manufactured to the highest quality standards, ensuring durability and long-lasting performance. Regularly tested and maintained, our blankets provide optimal reliability for continuous use in medical settings across Lucknow."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our warming blankets provide controlled, gentle warmth to prevent temperature-related complications during surgeries and procedures, ensuring that patients in Lucknow are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our patient warming blankets in Lucknow are adaptable to various healthcare settings, including hospitals, clinics, and emergency rooms. We work closely with healthcare providers to ensure our systems meet their specific needs, improving patient care and comfort."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s patient warming blankets are designed for easy integration with existing medical systems in Lucknow. Our products can be quickly implemented, ensuring smooth and efficient operation without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation services in Lucknow to help healthcare facilities choose the right patient warming blankets for their needs. Our team also offers ongoing support and maintenance to ensure your equipment operates efficiently and reliably."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of everything we do. Our patient warming blankets are designed to prevent temperature-related issues during critical medical procedures, ensuring that every patient in Lucknow receives the highest standard of care."
    }
]










  }


  const faqData = [
    { question: "What are Patient Warming Blankets?", answer: "Patient Warming Blankets are medical blankets designed to provide controlled warmth to maintain or regulate a patient's body temperature during medical procedures, reducing the risk of hypothermia and improving comfort." },
    { question: "How do Patient Warming Blankets work?", answer: "Patient Warming Blankets work by circulating warm air through the blanket, which gently warms the patient’s body. This helps maintain their body temperature within the normal range during surgeries or treatments." },
    { question: "Are Patient Warming Blankets available in Lucknow?", answer: "Yes, Pharmacle Health Care Private Limited offers Patient Warming Blankets in Lucknow, providing healthcare facilities with effective and reliable solutions for temperature management." },
    { question: "What are the benefits of using Patient Warming Blankets?", answer: "The main benefits include preventing hypothermia, reducing the risk of surgical complications, enhancing patient comfort, improving recovery times, and ensuring stable body temperature during medical procedures." },
    { question: "How long do Patient Warming Blankets maintain the patient’s temperature?", answer: "Patient Warming Blankets can maintain a patient’s body temperature for the entire duration of the medical procedure, ensuring consistent warmth and preventing body temperature fluctuations." },
    { question: "Are Patient Warming Blankets easy to use?", answer: "Yes, they are designed to be user-friendly with simple controls that make them easy for healthcare professionals to operate during surgeries or treatments." },
    { question: "Can Patient Warming Blankets be used in all types of surgeries?", answer: "Yes, Patient Warming Blankets are versatile and can be used in a wide range of surgeries, especially those that require temperature regulation for patient safety and comfort." },
    { question: "Are Patient Warming Blankets safe for all patients?", answer: "Yes, Patient Warming Blankets are safe for most patients, but they should always be used under the supervision of trained healthcare professionals to ensure optimal temperature regulation." },
    { question: "How can I purchase Patient Warming Blankets in Lucknow?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will assist you with purchasing and delivering Patient Warming Blankets to healthcare facilities in Lucknow." },
    { question: "Does Pharmacle Health Care provide support for Patient Warming Blankets?", answer: "Yes, we provide full support for Patient Warming Blankets, including installation, training for healthcare staff, and ongoing maintenance services to ensure the devices function effectively." }
  ];
  
  const testimonialsData = [
    {
      text: 'We have been using Patient Warming Blankets from Pharmacle Health Care in our Lucknow hospital, and they have greatly improved patient comfort and safety during surgeries, especially for longer procedures.',
      name: 'Dr. Rohit Singh',
    },
    {
      text: 'Pharmacle Health Care’s Patient Warming Blankets have been a valuable addition to our clinic in Lucknow. They are easy to use, effective, and have helped us provide better care for our patients during surgeries and treatments.',
      name: 'Dr. Neha Mishra',
    }
  ];
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Warming Blankets in Lucknow",
    "description": "Explore high-quality Patient Warming Blankets in Lucknow for effective patient thermoregulation. Our warming blankets ensure optimal comfort and temperature regulation during medical treatments and surgeries.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.7",
      "ratingCount": "1289"
    }
  };
  

  


  return (
    <div>
  <Helmet>
    <title>Patient Warming Blankets in Lucknow | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Explore Patient Warming Blankets in Lucknow for effective patient thermoregulation and temperature management during medical treatments. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Warming Blankets Lucknow, Lucknow Forced Air Warming Blankets, Warming Blankets for Patients in Lucknow, Patient Warming Systems Lucknow, Lucknow Medical Warming Blankets, Lucknow Patient Temperature Regulation Blankets"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/11.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientwarmingblanketslucknow;